import CXMApiClient from "../../CXMApiClient";

import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  pushToAutoVance: async function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/autovance/push_f_and_i",
      request,
      scope
    );

    return response;
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DMSPush/AutoVancePush.js